export default __webpack_public_path__ + "static/media/DerekGrossman.befc9bfa.jpg";